import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../hooks";
import { dashboardState } from "../../redux/reducers/dashboardReducer";
import { userState } from "../../redux/reducers/userReducer";

import stripLogo from "../../assets/strip.png";
import tikkieLogo from "../../assets/tikkieLogo.svg";
import { TwButton, TwFormHelperText, TwInputGroup, TwLabel, TwMainLayout, TwSelectGroup, TwSwitch } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { loadingState, setActionLoading, setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForBookings, getUrlForUsers } from "../../utils/confighelpers";
import { defaultAvailablePaymentMethods } from "../../utils/constants";
import StripPaymentMethod from "./StripPaymentMethod";

export default function BusinessPaymentProfile({ navigation, screenView }) {
  const { addToast, addSuccessToast, addErrorToast, addNotificationDialog, closeNotificationDialog } = useToast();
  const [userToken] = useLocalStorage("userToken");
  const dispatch = useDispatch();
  const loadingReduxState = useSelector(loadingState);
  const navigate = useNavigate();
  const location = useLocation();
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const [loading, setLoading] = React.useState(false);
  const [successMgModalOpen, setSuccessMgModalOpen] = React.useState(false);

  if (!userToken || userToken.length < 1) {
    navigate("/", { replace: true });
  }

  const handleFormValueChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    setIsThereChange(false)
  };

  const bodyData = {
    businessId: "",
    isEnabled: false,
    accountHolderName: "",
    appToken: "",
    paymentType: "Tikkie",
    addedByUserId: userReduxState.userData?._id,
    profileDetails: {
      accountHolderName: "",
      appToken: "",
    },
  };
  const stripeBodyData = {
    businessId: "",
    isEnabled: false,
    paymentType: "Stripe",
    profileDetails: {},
    stripeDetails: {
      // stripeAcId: "",
      // stripeEmail: "",
      // stripeCountry: "",
      // stripeOnBoardindStatus: "",
      // paymentMethod: {
      //   ideal: true,
      //   applePay: false,
      //   googlePay: false,
      //   creditCard: false,
      // }
    },
    addedByUserId: userReduxState.userData?._id,
  };

  const [formValues, setFormValues] = React.useState(bodyData);
  const [stripeFormValues, setStripeFormValues] = React.useState(stripeBodyData);
  const [isEditStripe, setIsEditStripe] = React.useState(false);
  const [isThereStripeChange, setIsThereStripeChange] = React.useState(true);
  const [formErrors, setFormErrors] = React.useState({});
  const [isEditTikkie, setIsEditTikkie] = React.useState(false);
  const [isThereChange, setIsThereChange] = React.useState(true);
  const [availablePaymentMethods, setAvailablePaymentMethods] = React.useState(defaultAvailablePaymentMethods);

  console.log("userReduxState?.userData", userReduxState?.userData);
  
  const [stripOnbordingFormValues, setStripOnbordingFormValues] = React.useState({
    email:  userReduxState?.userData?.myBusinessProfile?.workEmail ||"",
    country: "NL",
  });
  const [stripOnbordingFormErrors, setStripOnbordingFormErrors] = React.useState({});
  const [countryOpts, setEventCategoryOpts] = React.useState([
    { iso: "US", name: "United States" },
    { iso: "GB", name: "United Kingdom" },
    { iso: "NL", name: "Netherlands" },
    { iso: "IN", name: "India" },
  ]);

  const saveTikkiePaymentProfile = async () => {
    dispatch(setActionLoading(true));
    setIsThereChange(true);

    const errors = {};
    if (!formValues.accountHolderName) {
      errors.accountHolderName = "Required!";
    }
    if (!formValues.appToken) {
      errors.appToken = "Required!";
    }

    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      dispatch(setGlobalLoading(false));
      dispatch(setActionLoading(false));
      setIsThereChange(false);
      addErrorToast("Please fix errors", { hideAfter: 3 });
      return;
    }

    let body = {
      isEnabled: formValues.isEnabled,
      paymentType: formValues.paymentType,
      accountHolderName: formValues.accountHolderName,
      appToken: formValues.appToken,
      // // paymentType: formValues.paymentType,

      // myConnectedPaymentProfiles: {
      //   tikkie: {
      //     isEnabled: formValues.isEnabled,
      //     profileDetails: {
      //       accountHolderName: formValues.accountHolderName,
      //       appToken: formValues.appToken,
      //     },
      //   }
      // }
    };

    if (isEditTikkie) {
      body = {
        ...body,
        // businessId: formValues.businessId,
      }
    }
    await savePaymentProfile("tikkie", isEditTikkie, body);
    dispatch(setGlobalLoading(false));
    dispatch(setActionLoading(false));
    setIsThereChange(true);
  };
  const saveStripePaymentProfile = async () => {
    dispatch(setActionLoading(true));
    setIsThereStripeChange(true);
    const errors = {};
    // if (!stripeFormValues.stripeDetails.paymentMethod.ideal
    if (!stripeFormValues.profileDetails.paymentMethod.ideal
      && !stripeFormValues.profileDetails.paymentMethod.applePay
      && !stripeFormValues.profileDetails.paymentMethod.googlePay
      && !stripeFormValues.profileDetails.paymentMethod.creditCard) {
      errors.paymentMethod = "At least one payment Method needs to be enabled.";
    }
    if (!stripeFormValues.profileDetails.stripeAcId) {
      errors.stripeAcId = "Please connect with stripe account!";
    }

    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      dispatch(setGlobalLoading(false));
      dispatch(setActionLoading(false));
      setIsThereStripeChange(false);
      addErrorToast("Please fix errors", { hideAfter: 3 });
      return;
    }

    let body = {
      myConnectedPaymentProfiles: {
        stripe: {
          isEnabled: stripeFormValues.isEnabled,
          // paymentType: stripeFormValues.paymentType,
          // stripeDetails: stripeFormValues.stripeDetails,
          profileDetails: stripeFormValues.profileDetails,
        }
      }
    };

    if (isEditStripe) {
      body = {
        ...body,
      }
    }

    await savePaymentProfile("stripe", isEditStripe, body);
    dispatch(setActionLoading(false));
    setIsThereStripeChange(true);
  };

  const savePaymentProfile = async (editFor, isEdit, body) => {

    let config = {
      method: "post",
      url: `${getUrlForBookings()}payments/addPaymentProfile`,
      // method: "put",
      // url: `${getUrlForUsers()}updateProfile`,
      data: body,
    };
    if (isEdit) {
      config = {
        method: "PATCH",
        url: `${getUrlForBookings()}payments/updatePaymentProfile`,
        // method: "put",
        // url: `${getUrlForUsers()}updateProfile`,
        data: {
          ...body,
          // businessId: stripeFormValues.businessId,
        },
      }
      if (editFor === "stripe") {
        config = {
          ...config,
          method: "put",
          url: `${getUrlForUsers()}updateProfile`,
        }
      }
    }

    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    // const request = {};

    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        if (isEdit) {
          addNotificationDialog({
            dialogType: "success",
            dialogTitle: "Profile Changed Successfully",
            // dialogMessage: (request.data.message || "Profile successfully updated!"),
            dialogMessage: `${editFor} profile successfully updated!`,
            dialogBtnTitle: "Go back to Profile",
          })
        } else {

          addNotificationDialog({
            dialogType: "success",
            dialogTitle: "Well Done!",
            // dialogMessage: (request.data.message || "Profile successfully updated!"),
            dialogMessage: `Your customers will now be able to pay you directly to your account.`,
            dialogBtnTitle: "Go back to Dashboard",
            dialogBtnClick: async () => {
              closeNotificationDialog();
              navigate("/home/dashboard", { replace: true });
            },
          })
        }
        return;
      } else if (request.data.statusCode === 403) {
        addErrorToast("Something is wrong please try again");
        // addErrorToast(request.data.message);
      }
    }

  };

  const getPaymentProfile = async (loading = true) => {
    dispatch(setGlobalLoading(loading));
    const manageClassesConfig = {
      method: "get",
      // url: `${getUrlForClasses()}getPaymentProfile?to=all&teacherID=${userReduxState.userData?._id}`,
      url: `${getUrlForUsers()}getUserInfo`,
    };
    const manageClassesRequest = await axiosInstance(manageClassesConfig);
    dispatch(setGlobalLoading(false));
    if (manageClassesRequest.status === 200) {
      if (manageClassesRequest.data.statusCode === 403) {
        // setWarningText(manageClassesRequest.data.message.errors ? "Something is wrong please try again" : manageClassesRequest.data.message);
        setIsEditTikkie(false)
        setFormValues(bodyData)
        setIsThereChange(false)
      } else if (manageClassesRequest.data.statusCode === 200) {
        /* if (Array.isArray(manageClassesRequest.data.data)) {
          manageClassesRequest.data.data.map((d) => {
            if (d.paymentType === "Tikkie") {
              setIsEditTikkie(true);
              setFormValues({
                businessId: d._id,
                isEnabled: d.isEnabled,
                accountHolderName: d.accountHolderName,
                appToken: d.appToken,
                paymentType: d.paymentType,
                addedByUserId: userReduxState.userData?._id,
              })
              setIsThereChange(true)
            } else if (d.paymentType === "Stripe") {
              setIsEditStripe(true);
              setStripeFormValues({
                businessId: d._id,
                isEnabled: d.isEnabled,
                paymentType: d.paymentType,
                // stripeDetails: d.stripeDetails,
                stripeDetails: {
                  ...d.stripeDetails,
                  paymentMethod: {
                    ...d.stripeDetails?.paymentMethod,
                    ideal: d.stripeDetails?.paymentMethod?.ideal || false,
                    applePay: d.stripeDetails?.paymentMethod?.applePay || false,
                    googlePay: d.stripeDetails?.paymentMethod?.googlePay || false,
                    creditCard: d.stripeDetails?.paymentMethod?.creditCard || false,
                  },
                },
                addedByUserId: userReduxState.userData?._id,
              })
              setIsThereStripeChange(true)
            }
            return d;
          });
        } else */
        // if (manageClassesRequest.data.data.paymentType === "Stripe") {
        if (manageClassesRequest.data.data?.myConnectedPaymentProfiles?.stripe) {
          let stripeprofileDetails = manageClassesRequest.data.data.myConnectedPaymentProfiles.stripe
          // setIsEditStripe(true);
          setIsEditStripe(stripeprofileDetails?.profileDetails?.stripeAcId && stripeprofileDetails.profileDetails.stripeAcId !== "");
          setStripeFormValues({
            // businessId: manageClassesRequest.data.data._id,
            businessId: null,
            isEnabled: stripeprofileDetails.isEnabled,
            paymentType: "Stripe",
            // stripeDetails: manageClassesRequest.data.data.stripeDetails,
            // stripeDetails: {
            profileDetails: {
              ...stripeprofileDetails.profileDetails,
              stripeAcId: stripeprofileDetails?.profileDetails?.stripeAcId || "",
              stripeEmail: stripeprofileDetails?.profileDetails?.stripeEmail || "",
              stripeCountry: stripeprofileDetails?.profileDetails?.stripeCountry || "",
              stripeOnBoardindStatus: stripeprofileDetails?.profileDetails?.stripeOnBoardindStatus || "",
              paymentMethod: {
                ...stripeprofileDetails.profileDetails?.paymentMethod,
                ideal: stripeprofileDetails.profileDetails?.paymentMethod?.ideal?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.ideal : { enable: false, chargeToCustomer: false },
                applePay: stripeprofileDetails.profileDetails?.paymentMethod?.applePay?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.applePay : { enable: false, chargeToCustomer: false },
                googlePay: stripeprofileDetails.profileDetails?.paymentMethod?.googlePay?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.googlePay : { enable: false, chargeToCustomer: false },
                creditCard: stripeprofileDetails.profileDetails?.paymentMethod?.creditCard?.enable ? stripeprofileDetails.profileDetails?.paymentMethod?.creditCard : { enable: false, chargeToCustomer: false },
              },
            },
            addedByUserId: userReduxState.userData?._id,
          })
          setIsThereStripeChange(true)
        }
        if (manageClassesRequest.data.data?.myConnectedPaymentProfiles?.tikkie) {
          let tikkieprofileDetails = manageClassesRequest.data.data.myConnectedPaymentProfiles.tikkie
          // setIsEditTikkie(true);
          setIsEditTikkie(tikkieprofileDetails?.profileDetails?.accountHolderName && tikkieprofileDetails.profileDetails.accountHolderName !== "");
          setFormValues({
            // businessId: manageClassesRequest.data.data._id,
            businessId: null,
            isEnabled: tikkieprofileDetails.isEnabled,
            accountHolderName: tikkieprofileDetails.profileDetails.accountHolderName,
            appToken: tikkieprofileDetails.profileDetails.appToken,
            paymentType: "Tikkie",
            addedByUserId: userReduxState.userData?._id,
          })
          setIsThereChange(true)
        }
      }
    }
    await getAvailablePaymentMethods();
    dispatch(setGlobalLoading(false));
  };

  const getAvailablePaymentMethods = async () => {
    const requestConfig = {
      method: "get",
      url: `${getUrlForBookings()}payments/getAvailablePaymentMethods?teacherID=${userReduxState.userData?._id}&paymentMethodsFor=event&bookingFor=event`,
    };
    const response = await axiosInstance(requestConfig);
    if (response.status === 200) {
      if (response.data.statusCode === 403) {
      } else if (response.data.statusCode === 200) {
        if (response.data.data) {
          setAvailablePaymentMethods({
            ...{
              "payAtVenue": {
                "enable": false,
                "processingFeeApplicable": true,
                "reserveNowPaylater": true,
                "paymentGatewayServiceFee": {
                  "paymentProcessingFlatFee": 0,
                  "paymentProcessingPercentage": 0
                }
              }
            },
            ...response.data.data,
        })
        }
      }
    }
  };

  const createStripConnectedAC = async (body) => {
    // var child = window.open('https://www.plus2net.com/javascript_tutorial/window-child.html', '', 'toolbar=0,status=0,width=626,height=436');
    // child.onunload = function () { console.log('Child window closed'); };
    // var childWindow = window.open('https://abhijitsojitra.com', 'Stripe Onboarding', 'toolbar=0,status=0,width=626,height=436');
    // childWindow.document.location.href ='https://google.com';
    // var timer = setInterval(checkChild, 500);
    // setTimeout(() => {
    //   childWindow.close()
    // }, 5000);

    // var timer = setInterval(function () {
    //   if (childWindow.closed) {
    //     clearInterval(timer);
    //     alert('closed');
    //   }
    // }, 1000);
    // let popup = window.open("https://example.com", "_blank");

    // if (!popup || popup.closed || typeof popup.closed === "undefined") {
    //     alert("Popup was blocked!");
    // } else {
    //     alert("Popup opened successfully!");
    // }
    // return;
    const managemanageStripConnectedACConfig = {
      method: "post",
      url: `${getUrlForBookings()}payments/createConnectedAC`,
      data: {
        ...body,
        return_url: `${window.location.origin}/my-account/online-payment`,
      },
    };
    dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));
    const manageStripConnectedAC = await axiosInstance(managemanageStripConnectedACConfig);
    // dispatch(setGlobalLoading(false));
    // dispatch(setActionLoading(false));
    if (manageStripConnectedAC.status === 200) {
      if (manageStripConnectedAC.data.statusCode === 200) {
        if (manageStripConnectedAC.data?.data?.on_boarding_url && manageStripConnectedAC.data.data.on_boarding_url !== "") {

          // console.log("StripConnectedAC url", manageStripConnectedAC.data.data.on_boarding_url);
          // var childStripeWindow = window.open(manageStripConnectedAC.data.data.on_boarding_url, 'Stripe Onboarding', 'toolbar=0,status=0,width=800,height=600');
          window.location = manageStripConnectedAC.data.data.on_boarding_url;
          return;
          // var childStripeWindow = window.open(manageStripConnectedAC.data.data.on_boarding_url, "_blank");



          // if (!childStripeWindow || childStripeWindow.closed || typeof childStripeWindow.closed === "undefined") {
          //   dispatch(setGlobalLoading(false));
          //   dispatch(setActionLoading(false));
          //   addErrorToast("Popup was blocked!");
          //   return
          // }
          // if (childStripeWindow) {
          //   childStripeWindow.onload = function () {
          //     childStripeWindow.document.title = "Stripe Onboarding"; // Only works if same-origin
          //   };
          // }

          // var timer = setInterval(function () {

          //   if (childStripeWindow && childStripeWindow?.closed) {
          //     dispatch(setGlobalLoading(false));
          //     dispatch(setActionLoading(false));
          //     clearInterval(timer);
          //     clearInterval(timeInterval);
          //     // alert('closed');
          //   }
          // }, 1000);
          // if (childStripeWindow) {
          //   childStripeWindow.focus();
          // }
          // // childStripeWindow.addEventListener("beforeunload", function(event) {
          // //   // event.returnValue = "Are you sure that you want to cancel the transaction";
          // // });
          // var timeInterval = setInterval(async function () {
          //   await checkStripConnectedProcess(timeInterval, childStripeWindow)
          // }, 1000);
        } else {
          addNotificationDialog({
            dialogType: "error",
            dialogTitle: "An Error Occurred",
            dialogMessage: (manageStripConnectedAC.data.message || "Failed to create Stripe account: Could not verify provided information. Please check your details and try again."),
            dialogBtnTitle: "Go back",
          })
        }
      }
    }
  };

  const checkStripConnectedProcess = async (timeInterval, childStripeWindow) => {
    const managemanageStripConnectedACConfig = {
      method: "get",
      url: `${getUrlForBookings()}payments/stripeStatus`,
    };
    const manageStripConnectedAC = await axiosInstance(managemanageStripConnectedACConfig);
    if (manageStripConnectedAC.status === 200) {
      if (manageStripConnectedAC.data.statusCode === 200) {
        if (manageStripConnectedAC.data.data.stripeOnBoardindStatus == "SUCCESS") {
          try {
            if (childStripeWindow) {
              childStripeWindow.close()
            }
          } catch (error) {
            console.error(error);
          }
          clearInterval(timeInterval);
          dispatch(setGlobalLoading(false));
          // setCreateStripeDialog(false);
          getPaymentProfile();
        }
      }
    }
  };

  const renderLayout = (layoutType = "full", children) => {
    return layoutType === "tab" ? (children)
      : (layoutType === "full" ? (
        <TwMainLayout
          headTitle={"Payment Profile"}
          children={<>
            {((location?.state && location.state.hasOwnProperty("origin") && location.state?.origin === "paymentprofile") || userReduxState.businessType !== "event") && (<div className="">
              {children}
            </div>)}
          </>} />
      ) : (children));
  }

  React.useEffect(() => {
    getPaymentProfile(false);
  }, []);

  // React.useEffect(() => {
  //   console.log("stripeFormValues", stripeFormValues);
  //   console.log("stripeFormValues?.profileDetails?.stripeAcId", stripeFormValues?.profileDetails?.stripeAcId);
  // }, [stripeFormValues]);

  return renderLayout(screenView, (
    <div className={"flex flex-col md:p-3"}>
      <div className={"divide-y"}>
        <div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
          <div className="flex items-start gap-4">
            <img
              className={"rounded-md"}
              src={stripLogo}
              alt={""}
            />
            <div>
              <h2 className="text-base/7 font-semibold">Accept online payments via Stripe</h2>
              <p className="mt-1 text-sm/6 text-gray-400">Add your Stripe business account here to accept online payments, and get paid directly into your account. Manage all from a single app</p>
            </div>
          </div>
          <div className={"flex flex-col gap-4 md:col-span-2"}>
            <div>
              <TwSwitch
                title={"Enable Payments via Stripe"}
                name={"enablePaymentsViaStripe"}
                checked={stripeFormValues.isEnabled}
                onChange={(checked) => {
                  setStripeFormValues((prevValues) => ({
                    ...prevValues,
                    isEnabled: checked,
                  }))
                  setIsThereStripeChange(false)
                }}
                onClick={(event) => event.stopPropagation()}
              />
              <TwFormHelperText className="pt-2 text-xs sm:w-full md:max-w-lg">By enabling this, you agree that all payments and refunds will be handled between you and your customer automatically via your Stripe account.</TwFormHelperText>
            </div>

            {stripeFormValues?.profileDetails?.stripeAcId && stripeFormValues?.profileDetails?.stripeAcId !== "" && stripeFormValues?.profileDetails?.stripeOnBoardindStatus == "SUCCESS" ? (
              <>
                <TwInputGroup
                  label={"Name on the Stripe Account Id"}
                  placeholder={"e.g. Bookzy Incorporation"}
                  disabled={true}
                  value={stripeFormValues?.profileDetails?.stripeAcId}
                />
                <TwInputGroup
                  label={"Email on the Stripe Account"}
                  disabled={true}
                  value={stripeFormValues?.profileDetails?.stripeEmail}
                />
                <TwInputGroup
                  label={"Country on the Stripe Account"}
                  disabled={true}
                  value={stripeFormValues?.profileDetails?.stripeCountry}
                />
                <TwLabel error={formErrors["paymentMethod"] ? true : false}>Payment Method</TwLabel>
                <div className={"flex flex-col gap-4 sm:w-full md:max-w-lg"}>
                  <StripPaymentMethod
                    title="Ideal"
                    subTitle={`Payment processing fee: ${((availablePaymentMethods?.ideal?.paymentGatewayServiceFee?.paymentProcessingPercentage > 0 ? availablePaymentMethods?.ideal?.paymentGatewayServiceFee?.paymentProcessingPercentage + "% +" : "") || "")} ${(availablePaymentMethods?.ideal?.paymentGatewayServiceFee?.paymentProcessingFlatFee || 0)} Euro.`}
                    infoMessage=""
                    defaultSwitch={stripeFormValues?.profileDetails?.paymentMethod?.ideal?.enable || false}
                    defaultChargeToCustomerSwitch={stripeFormValues?.profileDetails?.paymentMethod?.ideal?.chargeToCustomer || false}
                    disabled={!stripeFormValues.isEnabled}
                    onSwitchChange={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            ideal: {
                              ...prevValues.profileDetails?.paymentMethod.ideal,
                              enable: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                    onSwitchChangeChargeToCustomer={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            ideal: {
                              ...prevValues.profileDetails?.paymentMethod.ideal,
                              chargeToCustomer: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                  />
                  <StripPaymentMethod
                    title="Apple Pay/Google Pay"
                    subTitle={`Payment processing fee: ${((availablePaymentMethods?.applePay?.paymentGatewayServiceFee?.paymentProcessingPercentage > 0 ? availablePaymentMethods?.applePay?.paymentGatewayServiceFee?.paymentProcessingPercentage + "% +" : "") || "")} ${(availablePaymentMethods?.applePay?.paymentGatewayServiceFee?.paymentProcessingFlatFee || 0)} Euro.`}
                    infoMessage=""
                    defaultSwitch={stripeFormValues?.profileDetails?.paymentMethod?.applePay?.enable || false}
                    defaultChargeToCustomerSwitch={stripeFormValues?.profileDetails?.paymentMethod?.applePay?.chargeToCustomer || false}
                    disabled={!stripeFormValues.isEnabled}
                    onSwitchChange={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            applePay: {
                              ...prevValues.profileDetails?.paymentMethod.applePay,
                              enable: checked,
                            },
                            googlePay: {
                              ...prevValues.profileDetails?.paymentMethod.googlePay,
                              enable: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                    onSwitchChangeChargeToCustomer={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            applePay: {
                              ...prevValues.profileDetails?.paymentMethod.applePay,
                              chargeToCustomer: checked,
                            },
                            googlePay: {
                              ...prevValues.profileDetails?.paymentMethod.googlePay,
                              chargeToCustomer: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                  />
                  <StripPaymentMethod
                    title="Credit Card"
                    subTitle={`Payment processing fee: ${((availablePaymentMethods?.creditCard?.paymentGatewayServiceFee?.paymentProcessingPercentage > 0 ? availablePaymentMethods?.creditCard?.paymentGatewayServiceFee?.paymentProcessingPercentage + "% +" : "") || "")} ${(availablePaymentMethods?.creditCard?.paymentGatewayServiceFee?.paymentProcessingFlatFee || 0)} Euro.`}
                    infoMessage=""
                    defaultSwitch={stripeFormValues?.profileDetails?.paymentMethod?.creditCard?.enable || false}
                    defaultChargeToCustomerSwitch={stripeFormValues?.profileDetails?.paymentMethod?.creditCard?.chargeToCustomer || false}
                    disabled={!stripeFormValues.isEnabled}
                    onSwitchChange={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            creditCard: {
                              ...prevValues.profileDetails?.paymentMethod.creditCard,
                              enable: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                    onSwitchChangeChargeToCustomer={(checked) => {
                      setStripeFormValues((prevValues) => ({
                        ...prevValues,
                        // stripeDetails: {
                        profileDetails: {
                          ...prevValues.profileDetails,
                          paymentMethod: {
                            ...prevValues.profileDetails?.paymentMethod,
                            creditCard: {
                              ...prevValues.profileDetails?.paymentMethod.creditCard,
                              chargeToCustomer: checked,
                            },
                          },
                        },
                      }))
                      setIsThereStripeChange(false)
                    }}
                  />
                </div>
                {formErrors["paymentMethod"] && (
                  <TwFormHelperText error={formErrors?.paymentMethod !== ""}>{formErrors["paymentMethod"]}</TwFormHelperText>
                )}
                {formErrors["stripeAcId"] && (
                  <TwFormHelperText error={formErrors?.stripeAcId !== ""}>{formErrors["stripeAcId"]}</TwFormHelperText>
                )}
                <div className={"flex flex-row items-center gap-2"}>
                  {/* {isThereStripeChange === true ? "true" : "false"} */}
                  <TwButton
                    className="sm:min-w-32"
                    // disabled={loadingReduxState.sectionLoading || isThereStripeChange}
                    disabled={loadingReduxState.actionLoading || isThereStripeChange}
                    actionLoading={(loadingReduxState.actionLoading)}
                    onClick={() => {
                      saveStripePaymentProfile();
                    }}
                  >
                    {isEditStripe ? "Update" : "Add my Stripe  Account"}
                  </TwButton>
                </div>
              </>) : stripeFormValues.isEnabled ? (
                <>
                  <TwInputGroup
                    label={"Email"}
                    name={"email"}
                    type={"email"}
                    placeholder={"Email"}
                    // leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                    value={stripOnbordingFormValues.email}
                    onChange={(event) => {
                      setStripOnbordingFormValues((prevValues) => ({
                        ...prevValues,
                        email: event.target.value,
                      }));
                    }}
                    errors={stripOnbordingFormErrors}
                  />
                  <TwSelectGroup
                    label={"Country"}
                    placeholder={"Select Country"}
                    name={"country"}
                    // leftIcon={(<img className={""} src={customer_name} alt={""} />)}
                    options={countryOpts.map((country, idx) => {
                      return { value: country.iso, title: country.name }
                    })}
                    defaultValue={countryOpts[2]}
                    value={stripOnbordingFormValues.country}
                    onChange={(event) => {
                      setStripOnbordingFormValues((prevValues) => ({
                        ...prevValues,
                        // country: event.target.value.iso,
                        country: event.target.value,
                      }));
                    }}
                    errors={stripOnbordingFormErrors} />
                  <div className={"flex flex-row items-center gap-2"}>
                    <TwButton
                      className="sm:min-w-32"
                      disabled={loadingReduxState.actionLoading}
                      actionLoading={(loadingReduxState.actionLoading)}
                      onClick={async () => {
                        const errors = {};
                        const emailpattern = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
                        if (!stripOnbordingFormValues.email) {
                          errors.email = "Required!";
                        } else if (stripOnbordingFormValues.email.length > 0 && emailpattern.test(stripOnbordingFormValues.email) === false) {
                          errors.email = "Please enter valid email";
                        }
                        if (!stripOnbordingFormValues.country) {
                          errors.country = "Required!";
                        }
                        setStripOnbordingFormErrors(errors)
                        if (Object.keys(errors).length === 0) {
                          await createStripConnectedAC(stripOnbordingFormValues);
                        }
                      }}
                    >
                      Add my Stripe Account
                    </TwButton>
                  </div>
                </>

              ) : null}
          </div>
        </div>
        {userReduxState.businessType !== "event" && (<div className="grid max-w-7xl grid-cols-1 gap-x-8 gap-y-10 px-4 py-16 md:px-6 md:grid-cols-3 lg:px-8">
          <div className="flex items-start gap-4">
            <img
              className={"rounded-md"}
              src={tikkieLogo}
              alt={""}
            />
            <div>
              <h2 className="text-base/7 font-semibold">Accept online payments via Tikkie</h2>
              <p className="mt-1 text-sm/6 text-gray-400">Add your Tikkie business account here to accept online payments, and  get paid directly into your account. Manage all from a single app</p>
              <p className="mt-1 text-xs text-gray-400">No processing fee | {availablePaymentMethods?.tikkie?.processingFeeApplicable ? (availablePaymentMethods?.tikkie?.paymentGatewayServiceFee?.paymentProcessingPercentage || 0) : 0}% commision</p>
            </div>
          </div>
          <div className={"flex flex-col gap-4 md:col-span-2"}>
            {availablePaymentMethods?.tikkie?.allowAccess ? (
              <>
                <div>
                  <TwSwitch
                    title={"Enable Payments via Tikkie"}
                    name={"enablePaymentsViaTikkie"}
                    checked={formValues.isEnabled}
                    onChange={(checked) => {
                      setFormValues((prevValues) => ({
                        ...prevValues,
                        isEnabled: checked,
                      }))
                      setIsThereChange(false)
                    }}
                    onClick={(event) => event.stopPropagation()}
                  />
                  <TwFormHelperText className="pt-2 text-xs sm:w-full md:max-w-lg">By enabling this, you agree that all payments and refunds will be handled between you and your customer directly via your Tikkie account, while Bookzy app will only act as digital enabler for those payments.</TwFormHelperText>
                </div>
                {(formValues.isEnabled || formValues.appToken) && (<>
                  <TwInputGroup
                    label={"Name on the Tikkie Account"}
                    name={"accountHolderName"}
                    placeholder={"e.g. Bookzy Incorporation"}
                    disabled={!formValues.isEnabled}
                    value={formValues.accountHolderName}
                    onChange={handleFormValueChange}
                  />
                  <TwInputGroup
                    label={"Enter your Tikkie appToken"}
                    name={"appToken"}
                    placeholder={"e.g. f1912413-6be9-4816-964c-8bba43d9e10f"}
                    disabled={!formValues.isEnabled}
                    value={typeof formValues.appToken == "string" ? formValues.appToken : ""}
                    onChange={handleFormValueChange}
                  />
                  <TwLabel>
                    <a className="text-sm mdtext-base cursor-pointer" href="https://bmcapp.s3.eu-west-1.amazonaws.com/teacher/handleiding_token+aanmaken_V2+(1).pdf" underline="none" rel="noreferrer" target="_blank">
                      Where to find this?
                      <svg className="inline align-middle cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.001 20H6.00098C4.89641 20 4.00098 19.1046 4.00098 18V7C4.00098 5.89543 4.89641 5 6.00098 5H10.001V7H6.00098V18H17.001V14H19.001V18C19.001 19.1046 18.1055 20 17.001 20ZM11.701 13.707L10.291 12.293L16.584 6H13.001V4H20.001V11H18.001V7.415L11.701 13.707Z" fill="#2E3A59" />
                      </svg>
                    </a>
                  </TwLabel>
                  <div className={"flex flex-row items-center gap-2"}>
                    {/* {isThereStripeChange === true ? "true" : "false"} */}
                    <TwButton
                      className="sm:min-w-32"
                      // disabled={loadingReduxState.sectionLoading || isThereStripeChange}
                      disabled={loadingReduxState.actionLoading || isThereChange}
                      actionLoading={loadingReduxState.actionLoading}
                      onClick={() => {
                        saveTikkiePaymentProfile();
                      }}
                    >
                      {isEditTikkie ? "Update" : "Add my Tikkie Account"}
                    </TwButton>
                  </div>
                  <div className="flex justify-center items-center mt-6 md:mt-10 sm:w-full md:max-w-lg">
                    <a className="text-sm mdtext-base text-gray-700 cursor-pointer" href="https://www.abnamro.nl/nl/zakelijk/producten/zakelijke-rekening/openen.html" underline="none" rel="noreferrer" target="_blank">
                      Do not have a Tikkie Business Account? <span className="text-portland-orange">Click here</span>
                      <svg className="inline align-middle cursor-pointer" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M17.001 20H6.00098C4.89641 20 4.00098 19.1046 4.00098 18V7C4.00098 5.89543 4.89641 5 6.00098 5H10.001V7H6.00098V18H17.001V14H19.001V18C19.001 19.1046 18.1055 20 17.001 20ZM11.701 13.707L10.291 12.293L16.584 6H13.001V4H20.001V11H18.001V7.415L11.701 13.707Z" fill="#2E3A59" />
                      </svg>
                    </a>
                  </div>
                </>)}
              </>) : (
              <>
                <TwLabel className="sm:w-full md:max-w-lg">
                  <p className="text-[#32282FCC] text-lg mt-4">
                    You need to subscribe to a paid subscription to enable payments through Tikkie
                  </p>
                </TwLabel>
                <div className={"flex flex-row items-center gap-2"}>
                  {/* {isThereChange === true ? "true" : "false"} */}
                  <TwButton
                    className="sm:min-w-32"
                    disabled={loadingReduxState.actionLoading || isThereChange}
                    actionLoading={(loadingReduxState.actionLoading)}
                    onClick={() => {
                      navigate("/businessprofilesetup/subscription", {
                        state: {
                          origin: "paymentprofile",
                        },
                        replace: true
                      });
                    }}
                  >
                    Go to Subscription
                  </TwButton>
                </div>
              </>
            )}
          </div>
        </div>)}
      </div>
    </div>
  ));
}
